import { useQuery } from 'react-query'
import RequestService from '../../services/request/request-service'
import { FACILITIES_LOCATIONS_QUERY } from '../constants/queries'

const useFacilityLocationQuery = ({ filter = { id: 0 } } = {}) => {
  return useQuery({
    queryKey: [FACILITIES_LOCATIONS_QUERY, filter],
    queryFn: async ({ queryKey }) => {
      const url = `${queryKey[0]}${filter?.id_facility !== 0 ? `?id=${filter?.id}` : ''}`
      const { data } = await RequestService.Get(url)
      return data
    },
    initialData: [],
  })
}
export default useFacilityLocationQuery
